module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "",
    staticStyle: {
      "border": "0px solid red"
    }
  }, [_c('div', {
    staticClass: "InfoTABPan"
  }, [_c('div', {
    staticClass: "InfoTAB2_A",
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm.getLangText("企业")))]), _vm._v(" "), _c('div', {
    staticClass: "InfoTAB2",
    staticStyle: {
      "margin-left": "10px"
    },
    on: {
      "click": _vm.onAcctInfoClick
    }
  }, [_vm._v(_vm._s(_vm.getLangText("账号")))]), _vm._v(" "), (_vm.custAiFlag) ? _c('div', {
    staticClass: "InfoTAB2",
    staticStyle: {
      "margin-left": "10px"
    },
    on: {
      "click": _vm.onAIInfoClick
    }
  }, [_vm._v(_vm._s(_vm.getLangText("AI接口")))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "SiftPanel",
    staticStyle: {
      "border": "0px solid #bbbbbb",
      "margin-top": "10px",
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "Capt DIVNoSelect",
    staticStyle: {
      "flex": "0 0 auto",
      "border": "0",
      "width": "350px",
      "margin-top": "-1px",
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm.getLangText('客户名称')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.custName),
      expression: "custName"
    }],
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "type": "text",
      "maxlength": "40"
    },
    domProps: {
      "value": (_vm.custName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.custName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "SiftPanel",
    staticStyle: {
      "border": "0px solid #bbbbbb"
    }
  }, [_c('div', {
    staticClass: "Capt DIVNoSelect",
    staticStyle: {
      "flex": "0 0 auto",
      "border": "0",
      "width": "350px",
      "margin-top": "-1px",
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm.getLangText('客户邮箱')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.custEmail),
      expression: "custEmail"
    }],
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "type": "text",
      "maxlength": "40"
    },
    domProps: {
      "value": (_vm.custEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.custEmail = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "SiftPanel",
    staticStyle: {
      "border": "0px solid #bbbbbb"
    }
  }, [_c('div', {
    staticClass: "Capt DIVNoSelect",
    staticStyle: {
      "flex": "0 0 auto",
      "border": "0",
      "width": "350px",
      "margin-top": "-1px",
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm.getLangText('客户定位')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.custLocate),
      expression: "custLocate"
    }],
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "type": "text",
      "maxlength": "40"
    },
    domProps: {
      "value": (_vm.custLocate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.custLocate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "SiftPanel",
    staticStyle: {
      "border": "0px solid #bbbbbb"
    }
  }, [_c('div', {
    staticClass: "Capt DIVNoSelect",
    staticStyle: {
      "flex": "0 0 auto",
      "border": "0",
      "width": "350px",
      "margin-top": "-1px",
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm.getLangText('设备开放公共资源')))]), _vm._v(" "), _c('radio', {
    ref: "idSourceFlag1",
    staticStyle: {
      "height": "30px",
      "margin-right": "20px"
    },
    attrs: {
      "size": 18,
      "root": {
        obj: this
      },
      "grpName": 'GrpSourceFlag',
      "val": 1,
      "capt": _vm.getLangText('可见')
    },
    model: {
      value: (_vm.chkSourceFlag),
      callback: function($$v) {
        _vm.chkSourceFlag = $$v
      },
      expression: "chkSourceFlag"
    }
  }), _vm._v(" "), _c('radio', {
    ref: "idSourceFlag0",
    staticStyle: {
      "height": "30px",
      "margin-right": "20px"
    },
    attrs: {
      "size": 18,
      "root": {
        obj: this
      },
      "grpName": 'GrpSourceFlag',
      "val": 0,
      "capt": _vm.getLangText('不可见')
    },
    model: {
      value: (_vm.chkSourceFlag),
      callback: function($$v) {
        _vm.chkSourceFlag = $$v
      },
      expression: "chkSourceFlag"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "SiftPanel",
    staticStyle: {
      "border": "0px solid #bbbbbb"
    }
  }, [_c('div', {
    staticClass: "Capt DIVNoSelect",
    staticStyle: {
      "flex": "0 0 auto",
      "border": "0",
      "width": "350px",
      "margin-top": "-1px",
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm.getLangText('设备开放公共模板')))]), _vm._v(" "), _c('radio', {
    ref: "idModelFlag1",
    staticStyle: {
      "height": "30px",
      "margin-right": "20px"
    },
    attrs: {
      "size": 18,
      "root": {
        obj: this
      },
      "grpName": 'GrpModelFlag',
      "val": 1,
      "capt": _vm.getLangText('可见')
    },
    model: {
      value: (_vm.chkModelFlag),
      callback: function($$v) {
        _vm.chkModelFlag = $$v
      },
      expression: "chkModelFlag"
    }
  }), _vm._v(" "), _c('radio', {
    ref: "idModelFlag0",
    staticStyle: {
      "height": "30px",
      "margin-right": "20px"
    },
    attrs: {
      "size": 18,
      "root": {
        obj: this
      },
      "grpName": 'GrpModelFlag',
      "val": 0,
      "capt": _vm.getLangText('不可见')
    },
    model: {
      value: (_vm.chkModelFlag),
      callback: function($$v) {
        _vm.chkModelFlag = $$v
      },
      expression: "chkModelFlag"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "SiftPanel",
    staticStyle: {
      "border": "0px solid #bbbbbb",
      "height": "250px"
    }
  }, [_c('div', {
    staticClass: "Capt DIVNoSelect",
    staticStyle: {
      "flex": "0 0 auto",
      "border": "0",
      "width": "350px",
      "margin-top": "-1px",
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm.getLangText('设备用Logo')))]), _vm._v(" "), _c('input', {
    ref: "idImgFile",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".jpg,.png"
    },
    on: {
      "change": _vm.onImgChange
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "width": "300px",
      "height": "200px",
      "margin-top": "10px",
      "border": "1px solid #bbbbbb",
      "display": "flex",
      "flex-direction": "column",
      "align-items": "center",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.onFileClick
    }
  }, [_c('img', {
    ref: "idImgPan",
    staticStyle: {
      "flex": "0 0 auto",
      "width": "300px",
      "height": "200px",
      "float": "left",
      "border": "0px solid red"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "width": "100%",
      "height": "12px",
      "margin-top": "200px"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "width": "297px",
      "height": "12px",
      "border-radius": "5px",
      "border": "1px solid #2a83cf",
      "margin-top": "6px",
      "display": "none",
      "position": "relative"
    }
  }, [_c('div', {
    ref: "idProgBar",
    staticStyle: {
      "position": "absolute",
      "width": "0%",
      "height": "10px",
      "line-height": "10px",
      "border-radius": "5px",
      "background": "#b4ea74"
    }
  }), _vm._v(" "), _c('div', {
    ref: "idProgCapt",
    staticStyle: {
      "position": "absolute",
      "width": "100%",
      "height": "10px",
      "line-height": "10px",
      "color": "#2a83cf",
      "text-align": "center",
      "font-size": "8px",
      "font-style": "italic"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "SiftPanel",
    staticStyle: {
      "border": "0px solid #bbbbbb",
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "Capt DIVNoSelect",
    staticStyle: {
      "flex": "0 0 auto",
      "border": "0",
      "width": "350px",
      "margin-top": "-1px",
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm.getLangText('收费标准')))]), _vm._v(" "), _c('div', {
    ref: "idP1",
    staticStyle: {
      "float": "left",
      "border": "0px solid red"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "margin-top": "6px",
      "padding-right": "6px"
    }
  }, [_vm._v(_vm._s(_vm.getLangText('一张:')))]), _vm._v(" "), _c('input', {
    ref: "idP1.price",
    staticStyle: {
      "float": "left",
      "width": "80px",
      "height": "30px"
    },
    attrs: {
      "type": "text",
      "maxlength": "11",
      "value": "0"
    }
  })]), _vm._v(" "), _c('div', {
    ref: "idP2",
    staticStyle: {
      "float": "left",
      "border": "0px solid red",
      "margin-left": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "margin-top": "6px",
      "padding-right": "6px"
    }
  }, [_vm._v(_vm._s(_vm.getLangText('二张:')))]), _vm._v(" "), _c('input', {
    ref: "idP2.price",
    staticStyle: {
      "float": "left",
      "width": "80px",
      "height": "30px"
    },
    attrs: {
      "type": "text",
      "maxlength": "11",
      "value": "0"
    }
  })]), _vm._v(" "), _c('div', {
    ref: "idP3",
    staticStyle: {
      "float": "left",
      "border": "0px solid red",
      "margin-left": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "margin-top": "6px",
      "padding-right": "6px"
    }
  }, [_vm._v(_vm._s(_vm.getLangText('三张:')))]), _vm._v(" "), _c('input', {
    ref: "idP3.price",
    staticStyle: {
      "float": "left",
      "width": "80px",
      "height": "30px"
    },
    attrs: {
      "type": "text",
      "maxlength": "11",
      "value": "0"
    }
  })]), _vm._v(" "), _c('div', {
    ref: "idP4",
    staticStyle: {
      "float": "left",
      "border": "0px solid red",
      "margin-left": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "margin-top": "6px",
      "padding-right": "6px"
    }
  }, [_vm._v(_vm._s(_vm.getLangText('四张:')))]), _vm._v(" "), _c('input', {
    ref: "idP4.price",
    staticStyle: {
      "float": "left",
      "width": "80px",
      "height": "30px"
    },
    attrs: {
      "type": "text",
      "maxlength": "11",
      "value": "0"
    }
  })]), _vm._v(" "), _c('div', {
    ref: "idP5",
    staticStyle: {
      "float": "left",
      "border": "0px solid red",
      "margin-left": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "margin-top": "6px",
      "padding-right": "6px"
    }
  }, [_vm._v(_vm._s(_vm.getLangText('五张:')))]), _vm._v(" "), _c('input', {
    ref: "idP5.price",
    staticStyle: {
      "float": "left",
      "width": "80px",
      "height": "30px"
    },
    attrs: {
      "type": "text",
      "maxlength": "11",
      "value": "0"
    }
  })])]), _vm._v(" "), (_vm.custAiFlag) ? _c('div', {
    staticClass: "SiftPanel",
    staticStyle: {
      "border": "0px solid #bbbbbb"
    }
  }, [_c('div', {
    staticClass: "Capt DIVNoSelect",
    staticStyle: {
      "flex": "0 0 auto",
      "border": "0",
      "width": "350px",
      "margin-top": "-1px",
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm.getLangText('AI预警次数') + '(50-1000)'))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.custAlarm),
      expression: "custAlarm"
    }],
    ref: "idAlarm",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "text",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.custAlarm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.custAlarm = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "width": "400px",
      "height": "40px",
      "border": "0px solid red",
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "NButton DIVNoSelect",
    staticStyle: {
      "width": "120px",
      "height": "36px",
      "float": "left",
      "margin-left": "400px"
    },
    on: {
      "click": _vm.onSaveClick
    }
  }, [_vm._v(_vm._s(_vm.getLangText("保存")))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6257b528","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/aiphoto/compInfo.vue
// module id = 790
// module chunks = 1